﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from '@fiqas/angular-utils';
import { FIQAssist } from "../../app";
import { IDisposable } from "../../interfaces/general"
import { TextEditorCommands } from "../../controls/editor/texteditor";
import { AuthenticationService } from "../../services/authenticationService";
import { AuthorizationService } from "../../services/authorizationService";
import { CaseFileData } from '../../models/file';

@Component({
    module: FIQAssist,
    selector: "richtexteditor",
    template: RichtextEditor.template
})
export class RichtextEditor implements IComponent {
    public static template = `<div class="editcontainer" style="width:100%;height:100%;position:relative;">
                <text-editor
                    editable="$ctrl.editable"
                    value="$ctrl.internalValue"
                    on-value-changed="$ctrl.oneditorvaluechanged(value)"
                    max-image-width="$ctrl.maxImageWidth"
                    max-image-height="$ctrl.maxImageHeight"
                    onfileadded="$ctrl.onNewAttachment(file)"
                    hint="{{::$ctrl.hint}}"
                ></text-editor>
                <pushicon tooltip-placement="bottom" uib-tooltip="{{ 'RTE_OPEN' | translate }}" tooltip-class="customTooltipTB" tooltip-is-open="$ctrl.maximizeTooltip" tooltip-append-to-body="true" onclicked="$ctrl.modal()" class='editorBtn editorBtnModal' icon="icon-resize" ng-hide="$ctrl.modalInstance"></pushicon>
                <pushicon tooltip-placement="bottom" uib-tooltip="{{ 'RTE_CLOSE' | translate }}" tooltip-class="customTooltipTB" tooltip-is-open="$ctrl.minimizeTooltip" tooltip-append-to-body="true" onclicked="$ctrl.modalClose()" class='editorBtn editorBtnModal' icon="icon-resizeback" ng-hide="!$ctrl.modalInstance || $ctrl.editable"></pushicon>
                <pushicon tooltip-placement="bottom" uib-tooltip="{{ 'RTE_EDIT' | translate }}" tooltip-class="customTooltipTB" tooltip-append-to-body="true" onclicked="$ctrl.edit()" class='editorBtn editorBtnEdit' icon="icon-edit" ng-hide="$ctrl.readOnly || $ctrl.editable"></pushicon>
                <pushicon tooltip-placement="bottom" uib-tooltip="{{ 'RTE_SAVE' | translate }}" tooltip-class="customTooltipTB" tooltip-append-to-body="true" onclicked="$ctrl.save()" class='editorBtn editorBtnSave' icon="icon-SAVE-CHECK" ng-show="$ctrl.editable"></pushicon>
                <pushicon tooltip-placement="bottom" uib-tooltip="{{ 'RTE_CANCEL' | translate }}" tooltip-class="customTooltipTB" tooltip-append-to-body="true" onclicked="$ctrl.cancel()" class='editorBtn editorBtnCancel' icon="icon-Clear-Edit" ng-show="$ctrl.editable"></pushicon>
               </div>`

    private disposables: IDisposable[] = [];

    @Attribute() public hint: string;
    @Input() public maxImageWidth: number;
    @Input() public maxImageHeight: number;

    @Output() public oneditstart: (args: { source: RichtextEditor }) => void;
    @Output() public oneditend: (args: { source: RichtextEditor, value: string }) => void;
    @Output() public oneditcancel: (args: { source: RichtextEditor }) => void;
    @Output() public onnewattachment: OutputArgs<{ attachment: CaseFileData }>;

    constructor(
        @Inject('$timeout') private $timeout: angular.ITimeoutService,
        @Inject('$scope') private $scope: angular.IScope,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService,
        @Inject('$uibModal') private $uibModal: angular.ui.bootstrap.IModalService,
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('AuthenticationService') private authenticationService: AuthenticationService,
        @Inject('AuthorizationService') private authorizationService: AuthorizationService
    ) {
        this.editable = false;
    }

    $onInit() {
        this.$rootScope.$emit('richTextEditorInitialized', this);
    }

    private save() {
        if (this.hasValue && this.internalValue && this.internalValue.length && this.internalValue.length > 0) {
            let changed = false;
            if (this._value != this.internalValue) {
                changed = true;
                this._value = this.internalValue;
            }
            this.editable = false;
            if (changed)
                this.oneditend({ source: this, value: this.value });
        }
    }

    private edit() {
        this.editable = true;
        if (this.editable) {
            this.oneditstart({ source: this });
            this.$scope.$broadcast(TextEditorCommands.CursorAtEnd);
        }
    }

    public async cancel() {
        this.internalValue = "";
        await this.$timeout();
        this.internalValue = this._value;
        this.editable = false;
        this.oneditcancel({ source: this });
    }



    private internalValue: string;
    private oneditorvaluechanged(value) {
        this.internalValue = value;
    }

    private _value: string;

    @Input()
    public get value() {
        return this._value;
    }

    public set value(v: string) {
        this._value = v;
        this.internalValue = v;
    }

    private stripRichTextRegex: any = /(?!.img.*src.+)(<([^>]+)>)|&nbsp;|\s/ig;
    private get hasValue() {
        return this.internalValue !== null && this.internalValue !== undefined && this.internalValue.replace(this.stripRichTextRegex, "") !== "";
    }

    @Attribute()
    public language: string;

    @Output() onEditableChanged: (args: { editable: boolean }) => void;

    private _editable: boolean;
    private get editable(): boolean {
        return this._editable;
    }
    private set editable(value: boolean) {
        let e = this._editable;
        this._editable = value && !this._readOnly;
        if (e != this._editable)
            this.onEditableChanged({ editable: this._editable });
    }
    private _readOnly: boolean;
    @Input()
    public get readOnly() {
        return this._readOnly;
    }
    public set readOnly(value: boolean) {
        this._readOnly = value;
    }

    public onNewAttachment(fileData: CaseFileData) {
        this.onnewattachment({ attachment: fileData });
    }

    private minimizeTooltip: boolean = false;
    private maximizeTooltip: boolean = false;
    private modalInstance: angular.ui.bootstrap.IModalServiceInstance;
    public async modal() {
        this.maximizeTooltip = false;
        let div;
        let adiv = this.$element.find("div");
        angular.forEach(adiv, d => {
            if (d.className.indexOf("editcontainer") > -1)
                div = d;
        })
        let controller = ($scope: angular.IScope) => {
            $scope.$on("modal.closing", e => {
                if (this.editable)
                    e.preventDefault();
                else
                    this.$element.append(div);
            });
        }
        controller.$inject = ['$scope'];
        this.modalInstance = this.$uibModal.open({
            scope: this.$scope,
            appendTo: this.$element,
            size: 'lg',
            template: "<div><modal></modal></div>",
            controller: controller
        });
        this.modalInstance.closed.finally(() => { this.modalInstance = null; });
        this.modalInstance.result.catch(_ => { })
        await this.modalInstance.rendered;
        let modal = this.$element.find("modal")
        modal.replaceWith(div);
    }
    public async modalClose() {
        this.minimizeTooltip = false;
        this.$timeout(() => this.modalInstance.close(), 20);
    }
}
